export type SubjectId = 'methods' | 'specialist';
export type YearLevel = 11 | 12;
export type StartMode = 'diagnostic' | 'beginning';

export interface SubjectUnit {
  title: string;
  topics: string[];
}

export interface Subject {
  id: SubjectId;
  name: string;
  short_code: string;
  colour: string;
  tagline: string;
  placeholder: boolean;
  units: SubjectUnit[];
}

export interface SubjectProgress {
  answered: number;
  correct: number;
  question_count: number;
  percent: number;
  xp: number;
}

export interface Enrolment {
  subject_id: SubjectId;
  year_level: YearLevel | null;
  start_mode: StartMode | null;
  hidden: boolean;
  last_opened_at: string;
  first_run: boolean;
  progress: SubjectProgress;
}

export interface SubjectsPayload {
  catalogue: Subject[];
  subjects: Enrolment[];
  last_used: SubjectId;
  total_xp: number;
}

export interface EnrolledSubject extends Subject {
  enrolment: Enrolment;
}

export const DEFAULT_SUBJECT_ID: SubjectId = 'methods';

export const enrolledSubjects = (payload: SubjectsPayload): EnrolledSubject[] =>
  payload.subjects.flatMap((enrolment) => {
    const subject = payload.catalogue.find((item) => item.id === enrolment.subject_id);
    return subject ? [{ ...subject, enrolment }] : [];
  });

export const progressLabel = ({ answered, percent }: SubjectProgress): string =>
  answered === 0 ? 'Not started' : `${percent}% complete`;
